<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading" :btnRefreshVisible="false" @refresh="onRefresh">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data Dal</label>
                        <date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="filtro.dataDal" type="date"></date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data Al</label>
                        <date-picker :disabled-date="notBeforeDataDal" format="DD-MM-YYYY" value-type="timestamp" v-model="filtro.dataAl" type="date"></date-picker>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-paziente-parametri-vitali-list-component ref="cmpRsaPazienteParametriVitaliList"></rsa-paziente-parametri-vitali-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaPazienteParametriVitaliListComponent from "../../rsagestioneospiti/components/RsaPazienteParametriVitaliListComponent.vue";

export default {
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaPazienteParametriVitaliListComponent,
        DatePicker,
    },
    data() {
        return {
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            btnNewVisible: true,
            pathResource: null,
            pathResourceAccettazione: "/accettazioni",
            linkedit: null,
            filtro: { idPaziente: null, dataDal: null, dataAl: null },
            linkback: "/rsagestioneospiti",
            showModalLoading: false,
            listKey: 0,
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        me.filtro.idPaziente = me.idAccettazione;
        me.filtro.dataAl = new Date().getTime() + 24 * 60 * 60 * 1000;
        me.filtro.dataDal = me.filtro.dataAl - 30 * 24 * 60 * 60 * 1000;
        me.loadAccettazione();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpRsaPazienteParametriVitaliList.loadData(me.filtro, me.jsonData);
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onRefresh() {
            let me = this;
            me.$refs.cmpRsaPazienteParametriVitaliList.loadData(me.filtro);
        },
        onReset() {
            let me = this;
            // me.filtro = { idPaziente: null, dataDal: null, dataAl: null };
            me.filtro.idPaziente = me.idAccettazione;
            me.filtro.dataAl = new Date().getTime();
            me.filtro.dataDal = me.filtro.dataAl - 30 * 24 * 60 * 60 * 1000;
            me.$refs.cmpRsaPazienteParametriVitaliList.loadData(me.filtro);
        },
        onSubmit() {
            let me = this;
            me.$refs.cmpRsaPazienteParametriVitaliList.loadData(me.filtro);
        },
        notBeforeDataDal(date) {
            let me = this;
            return date < me.filtro.dataDal;
        },
    },
};
</script>

<style></style>
